<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "BillingCliRate",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  